/**
 * UC-44: LoadTooltipContent
 */
import type { IAppLogger } from '../../domain/ports/IAppLogger';
import type { ITooltipContentPort } from '../../domain/ports/ITooltipContentPort';

export interface LoadTooltipContentOutput {
  ok: boolean;
  ready: boolean;
  error?: string;
}

export interface LoadTooltipContentDependencies {
  tooltipContent: ITooltipContentPort;
  logger?: IAppLogger;
}

export class LoadTooltipContentUseCase {
  constructor(private readonly deps: LoadTooltipContentDependencies) {}

  async execute(): Promise<LoadTooltipContentOutput> {
    try {
      await this.deps.tooltipContent.initialize();
      const ready = this.deps.tooltipContent.isReady();

      this.deps.logger?.log('debug', 'tooltip.content_loaded', { ready });

      return { ok: true, ready };
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      this.deps.logger?.log('warn', 'tooltip.load_failed', { error: message });
      return { ok: false, ready: false, error: message };
    }
  }
}